import { Fragment } from "react";
import { IVariableOperationsGpsBonusSetup } from "@/PayPlans/types/sections/variableOperationsGpsBonus";
import { allowedGPSKeys, filterByInterface, getObjectsWithConfiguredCommission } from "../../utils";
import { isArray, isObject } from "lodash";
import EligibilityTiers from "../EligibilityTiers";
import { Divider } from "@mui/material";

function renameBonusKeys(input: any): any {
	if (isArray(input)) {
		return input.map((item) => renameBonusKeys(item));
	}

	if (isObject(input)) {
		const result: any = {};

		Object.entries(input).forEach(([key, value]) => {
			let newKey = key;

			if (key === "bonuses") newKey = "commissions";
			if (key === "bonus") newKey = "commission";

			result[newKey] = renameBonusKeys(value);
		});

		return result;
	}

	return input; // primitive
}

type GpsContentProps = {
	spiffType: string;
	requirements: IVariableOperationsGpsBonusSetup;
};

const GpsContent = (props: GpsContentProps) => {
	const { spiffType, requirements } = props;
	const formattedRequirements = renameBonusKeys(filterByInterface(requirements, allowedGPSKeys));
	const { combineFranchises, globalUnitCounts } = formattedRequirements;
	const cleanRequirements = getObjectsWithConfiguredCommission(formattedRequirements);
	const length = cleanRequirements.length;
	return (
		<>
			{cleanRequirements.map(({ make, tiers }: any, index: number) => {
				const informationMessage = [];
				if (combineFranchises) {
					informationMessage.push("Franchises Combined");
				}
				if (globalUnitCounts) {
					informationMessage.push("Global Unit Counts");
				}
				const franchises = make === "Combined" ? ["New Vehicles"] : [make];
				return (
					<Fragment key={make}>
						<EligibilityTiers
							franchises={franchises}
							tiers={tiers}
							tiersHeaderTitle="Unregistered Consumers"
							informationMessage={informationMessage}
							verticalText={
								<>
									<span>Deals out of</span>
									<br />
									<span>Compliance</span>
								</>
							}
							verticalTextClassName="!text-sm !text-default !font-montserrat !font-medium !mt-20 !-rotate-90"
							commissionColumnsTitle="Bonus"
							spiffType={spiffType}
						/>
						{index !== length - 1 && <Divider className="!mt-10 !mb-6" />}
					</Fragment>
				);
			})}
		</>
	);
};

export default GpsContent;
